import { createSlice, PayloadAction } from '@reduxjs/toolkit';


export interface LagDropdown {
  foreCastAnalysisLagForSt?: null | number;
  foreCastAnalysisLagForMt?: null | number;
  predefinedLagForSt?: null | number;
  predefinedLagForMt?: null | number;
  experimentLagForSt?: null | number;
  experimentLagForMt?: null | number;
  experimentLoader?: boolean;
  predefinedLoader?: boolean;
}
// Initial state
const initialState: LagDropdown = {
  foreCastAnalysisLagForSt: null,
  foreCastAnalysisLagForMt: null,
  predefinedLagForSt: null,
  predefinedLagForMt: null,
  experimentLagForSt: null,
  experimentLagForMt: null,
  experimentLoader: false,
  predefinedLoader: false
};


export const lagDropdownSlice = createSlice({
  name: "lagDropdownSlice",
  initialState,
  reducers: {

    setForeCastAnalysisLagForSt: (state, action: PayloadAction<number | null>) => {
          state.foreCastAnalysisLagForSt = action.payload;
    },
    setForeCastAnalysisLagForMt: (state, action: PayloadAction<number | null>) => {
      state.foreCastAnalysisLagForMt = action.payload;
    },

    setPredefinedLagForSt: (state, action: PayloadAction<number | null>) => {
        state.predefinedLagForSt = action.payload;
    },

    setPredefinedLagForMt: (state, action: PayloadAction<number | null>) => {
      state.predefinedLagForMt = action.payload;
    },

    setExperimentLagForSt: (state, action: PayloadAction<number | null>) => {
      state.experimentLagForSt = action.payload;
  },

    setExperimentLagForMt: (state, action: PayloadAction<number | null>) => {
      state.experimentLagForMt = action.payload;
    }, 
    
    setExperimentLoader: (state, action: PayloadAction<boolean>) => {
      state.experimentLoader = action.payload;
    }, 

    setPredefinedLoader: (state, action: PayloadAction<boolean>) => {
      state.predefinedLoader = action.payload;
    }, 
  },
});

export const { setForeCastAnalysisLagForSt, setForeCastAnalysisLagForMt,  setPredefinedLagForSt, setPredefinedLagForMt, setExperimentLagForSt, setExperimentLagForMt, setExperimentLoader, setPredefinedLoader} = lagDropdownSlice.actions;
export default lagDropdownSlice.reducer;

